"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.from");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _ChangTime = _interopRequireDefault(require("./ChangTime.vue"));
var _index = _interopRequireDefault(require("@/components/Store/AddEditStoreModel/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
var _index3 = require("../statics/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** mixins */
/** statics */
// 类型 ，计划、任务，由前端自行维护
var _default2 = exports.default = {
  components: {
    ChangTime: _ChangTime.default,
    AddEditStoreModel: _index.default,
    RangePick: _index2.default
  },
  mixins: [_myform.default, _timeConflit.default],
  props: {
    // 左侧table选中的date具体信息
    actDateinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     * optConfig.rtmOptions: [], // 门店RTM类型select
     * optConfig.storeCategoryOptions: [], // 客户类型select（零售店类别）
     * optConfig.tppOptions: [], // TPP签约量select
     * optConfig.storeStructureOptions: [], // 零售店性质select
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     * optConfig.daMethodOptions: [], // 记账方式select
     * optConfig.tireSupplierOptions: [], // 主要进货渠道select
     * optConfig.accountMethodOptions: [], // 结算方式select
     * optConfig.tyreBrandOptions: [], // 轮胎品牌select
     * optConfig.mainserviceOptions: [], // 主要服务项目select
     * optConfig.asmVisitPurposeOptions: [], // ASM拜访目的select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    srList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    var defaultForm = {
      planTaskStartTime: '',
      planTaskEndTime: ''
    };
    var validateSR = function validateSR(rule, value, callback) {
      if (!_this.taskForm.srEmpNo) {
        callback(new Error(_this.$t('errorValid.emptySelect')));
      } else {
        callback();
      }
    };
    var default_SearchForm = {
      rtlFullName: '',
      // 门店名称
      rtlSapId: '',
      // 门店编号
      contactsNameOne: '',
      // 门店联系人
      tppGySign: '',
      // 固特异TPP签约量
      PCD: [],
      // 省市区 不传后端
      rtlRegion: '',
      // 省label
      rtlRegionCode: '',
      // 省
      rtlCity: '',
      // 市label
      rtlCityCode: '',
      // 市
      rtlDistrict: '',
      // 区label
      rtlDistrictCode: '',
      // 区
      rtlAddress: '',
      // 门店地址
      retailerType: '',
      // 店面级别（零售店类别）
      rtlRtmCategory: '',
      // 客户类型(零售店RTM类型)
      isBaiLian: ''
    };
    return {
      onlyRead: false,
      PT_STATUS_TASK: _index3.PT_STATUS_TASK,
      // 任务
      actualPlanTaskFlag: '',
      // Y:实际任务；N:计划任务
      planTaskType: '',
      //任务类型
      /** form group */
      formLabelWidth: '120px',
      isShowModel: false,
      // visible
      dialogStatus: 'create',
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      regionProps: {
        expandTrigger: 'hover',
        checkStrictly: true
      },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      taskForm: {
        srEmpNo: '',
        customerName: '',
        //潜在客户名称
        customerAddress: '',
        //潜在客户地址
        visitPurpose1: '',
        // 拜访目的1
        visitPurpose2: '',
        // 拜访目的2
        asmVisitPurpose: '',
        // ASM拜访目的
        remark: '' // 拜访目的的简要说明
      },
      rules: {
        validateIpt: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.empty')
        }],
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** search + table */
      searchForm: Object.assign({}, default_SearchForm),
      table: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {} // 访店任务流程 store info
      },
      storeSelectedInfo: [],
      // 查看详情时展示已选门店
      /** other */
      canSubmit: true,
      /** 时间分割弹窗数据 */
      changeTime: {
        visible: false,
        // 是否显示时间分割弹窗
        storelist: [] // 需要变更时间的列表
      },
      validateSR: validateSR
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return "".concat(this.dialogStatus === 'edit' ? this.$t('common.edit') : this.$t('common.create')).concat(this.$t('doubleWeekPlan.title.storeToVisit'), "\uFF1A").concat(this.actDateinfo.planTaskDateStr || '');
    },
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    },
    // 是创建任务流程
    isTask: function isTask() {
      return this.actualPlanTaskFlag === _index3.PT_STATUS_TASK;
    },
    // 是否已选择门店
    isStoreSelected: function isStoreSelected() {
      return !!this.table.taskStoreChecked.storeCode;
    },
    // 是否选择SR
    isSrEmpNoSelected: function isSrEmpNoSelected() {
      return !!this.taskForm.srEmpNo;
    }
  },
  watch: {
    isShowModel: {
      handler: function handler(val, old) {
        if (val !== old && !val) {
          this.resetModel();
        }
      }
    },
    'taskForm.srEmpNo': {
      handler: function handler(val, old) {
        this.searchData();
        this.table.taskStoreChecked = ''; // 重置门店选择
      }
    }
  },
  methods: {
    // open dialog init
    init: function init(type, data) {
      // 没有选中日期不能操作
      if (!this.actDateinfo.planTaskDate) {
        return false;
      }
      this.isShowModel = true;
      this.actualPlanTaskFlag = type;
      // 根据ba描述，目前门店计划没编辑
      this.queryList();
      if (!!data) {
        this.onlyRead = true;
        this.form = {
          planTaskStartTime: data.planTaskStartTime,
          planTaskEndTime: data.planTaskEndTime
        };
        this.initForm = this.form;
        this.taskForm = {
          srEmpNo: data.srEmpNo,
          customerName: data.customerName,
          //潜在客户名称
          customerAddress: data.customerAddress,
          //潜在客户地址
          visitPurpose1: data.visitPurposeOne,
          // 拜访目的1
          visitPurpose2: data.visitPurposeTwo,
          // 拜访目的2
          asmVisitPurpose: data.asmVisitPurpose,
          remark: data.remark // 拜访目的的简要说明
        };
        this.storeSelectedInfo = [{
          storeCode: data.storeCode,
          storeName: data.storeName,
          storeAddress: data.storeAddress,
          contactor: data.contactor
        }];
        this.table.taskStoreChecked = this.storeSelectedInfo[0];
      }
    },
    // get table list
    queryList: function queryList() {
      var _this2 = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({
          srEmpNo: this.taskForm.srEmpNo,
          visitFlag: 'Y'
        }, others)
      };
      this.table.listLoading = true;
      this.$api.retailorStore.getList(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res || {},
          data = _ref.data;
        var _ref2 = data || {},
          _ref2$items = _ref2.items,
          items = _ref2$items === void 0 ? [] : _ref2$items,
          _ref2$totalCount = _ref2.totalCount,
          totalCount = _ref2$totalCount === void 0 ? 0 : _ref2$totalCount;
        _this2.table.list = items;
        _this2.table.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this2.table.listLoading = false;
      });
    },
    // search table
    searchData: function searchData() {
      // console.log(999, this.searchForm)
      this.table.currPage = 1;
      this.queryList();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchForm = data.searchForm;
      this.searchData();
    },
    // store checked event
    handleStoreChecked: function handleStoreChecked(rows) {
      // console.log(999, rows)
      if (this.table.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.storeCode;
      });
      // 当前页取消选中
      var unCheckedRows = this.table.list.filter(function (i) {
        return checkedCodes.indexOf(i.storeCode) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.storeCode;
      });
      var rowsMap = new Map();
      this.table.storeChecked.concat(rows).forEach(function (i) {
        rowsMap.set(i.storeCode, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.storeCode) < 0;
      });
      this.table.storeChecked = arr;
    },
    // 新开卡（新增门店）
    onAddStore: function onAddStore() {
      this.$refs['addEditStoreModel'].init();
    },
    // 取消按钮前置操作
    onBeforeCancel: function onBeforeCancel() {
      if (this.changeTime.visible) {
        // 时间分割step特殊处理
        this.clearChangeTime();
        return false;
      } else {
        // 默认执行cancel方法
        return true;
      }
    },
    // 任务 单选
    getCurrentRow: function getCurrentRow(row) {
      if (row.rtlSapId === this.table.taskStoreChecked.rtlSapId) {
        this.table.taskStoreChecked = '';
        return;
      }
      this.table.taskStoreChecked = Object.assign({}, row);
    },
    // 保存任务
    saveItem: function () {
      var _saveItem = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var valid1, valid2, params;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.onlyRead) {
                _context.n = 1;
                break;
              }
              this.isShowModel = false;
              return _context.a(2);
            case 1:
              this.$refs['dataForm'].clearValidate();
              this.$refs['taskForm'].clearValidate();
              _context.n = 2;
              return this.$refs['dataForm'].validate().catch(function (err) {
                return err;
              });
            case 2:
              valid1 = _context.v;
              _context.n = 3;
              return this.$refs['taskForm'].validate().catch(function (err) {
                return err;
              });
            case 3:
              valid2 = _context.v;
              if (!(valid1 !== true || valid2 !== true)) {
                _context.n = 4;
                break;
              }
              if (valid1 !== true) {
                this.$message.error(this.$t('doubleWeekPlan.error.planRangeTime'));
              } else if (valid2 !== true) {
                this.$message.error(this.$t('doubleWeekPlan.error.taskTarget'));
              }
              return _context.a(2);
            case 4:
              if (this.canSubmit) {
                _context.n = 5;
                break;
              }
              return _context.a(2, false);
            case 5:
              this.canSubmit = false;
              params = {
                actualPlanTaskFlag: this.actualPlanTaskFlag,
                planTaskDate: this.actDateinfo.planTaskDate || '',
                planTaskType: 'A01',
                // 客户拜访固定类型
                // planTaskType: this.planTaskType,
                detailList: [(0, _objectSpread2.default)({
                  planTaskStartTime: this.form.planTaskStartTime,
                  planTaskEndTime: this.form.planTaskEndTime,
                  storeCode: this.table.taskStoreChecked.rtlSapId
                }, this.taskForm)]
              }; // 实际保存
              this.api_save(params);
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function saveItem() {
        return _saveItem.apply(this, arguments);
      }
      return saveItem;
    }(),
    // api 保存方法
    api_save: function api_save(params, isStep2) {
      var _this3 = this;
      (0, _doubleWeekPlan.savePlanTask)(params).then(function () {
        _this3.$message({
          message: _this3.$t('common.saveSuccess'),
          type: 'success'
        });
        _this3.$emit('refresh');
        _this3.isShowModel = false;
      }).catch(function (err) {
        if (isStep2) {
          // 在changeTime组件内反馈
          _this3.$refs['changeTimeRef'].errHandle(err);
        } else {
          // 在当前组件内反馈
          _this3.errorHandle(err, 'dataForm');
        }
        // 如果是时间冲突了，则弹出冲突弹窗
        var _params$detailList = params.detailList,
          detailList = _params$detailList === void 0 ? [] : _params$detailList,
          actualPlanTaskFlag = params.actualPlanTaskFlag,
          planTaskDate = params.planTaskDate;
        var conflitParams = {
          actualPlanTaskFlag: actualPlanTaskFlag,
          planTaskDate: planTaskDate,
          timeList: detailList.map(function (i) {
            return {
              startTime: i.planTaskStartTime,
              endTime: i.planTaskEndTime
            };
          })
        };
        _this3.timeConflitHandle(err.errorInfos, conflitParams);
      }).finally(function () {
        _this3.canSubmit = true;
      });
    },
    // 重置弹窗
    resetModel: function resetModel() {
      this.canSubmit = true;
      this.onlyRead = false;
      this.clearForm();
      this.clearTable();
      this.clearChangeTime();
    },
    // reset form
    clearForm: function clearForm() {
      console.log('clear form');
      try {
        var dataFormDom = this.$refs['dataForm'];
        var searchFormDom = this.$refs['searchForm'];
        dataFormDom && dataFormDom.resetFields();
        searchFormDom && searchFormDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.form = data.form;
      this.initForm = data.initForm;
      this.searchForm = data.searchForm;
      this.taskForm = data.taskForm;
    },
    clearTable: function clearTable() {
      var data = this.$options.data.call(this);
      this.table = data.table;
      this.storeSelectedInfo = data.storeSelectedInfo;
    },
    // 重置时间分割弹窗
    clearChangeTime: function clearChangeTime() {
      try {
        var changeTimeDom = this.$refs['changeTimeRef'];
        changeTimeDom && changeTimeDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.changeTime = data.changeTime;
    }
  }
};